import { commentIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const MessageBubble = createIcon({
  displayName: 'MessageBubble',
  paths: [
    'M170.667 640v-426.667h682.667v426.667h-682.667zM853.333 128h-682.667c-47.104 0-85.333 38.229-85.333 85.333v426.667c0 47.104 38.229 85.333 85.333 85.333h42.667v170.667l204.8-170.667h435.2c47.104 0 85.333-38.229 85.333-85.333v-426.667c0-47.104-38.229-85.333-85.333-85.333zM298.667 554.667h256c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-256c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM725.333 384h-426.667c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h426.667c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667z'
  ],
  canvasPaths: canvasIconPaths(commentIcon)
})
